"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class LocationAPI {
    client;
    constructor(client) {
        this.client = client;
    }
    async getLocation(locationSlug) {
        return await this.client.get(`/locations?slug=${locationSlug}`);
    }
    async getLocationSettings(locationID) {
        return await this.client.get(`/locations/${locationID}/settings`);
    }
    async getLocations(brandId) {
        return (await this.client.get(`/locations?brandId=${brandId}&limit=100`))?.results;
    }
    async getMyLikedItems(locationId) {
        return await this.client.get(`/locations/${locationId}/my-likes`);
    }
    async updateLocation(locationId, body) {
        // Once we replace Olympus.Partner.Location with Olympus.Partner.Location
        // return this.client.client.locations.location.updateLocation({
        //   params: { locationId },
        //   body,
        // })
        return await this.client.patch(`locations/${locationId}`, body);
    }
    async updateLocationTablet(locationId, body) {
        // Once we replace Olympus.Partner.Location with Olympus.Partner.Location
        // return await this.client.client.locations.location.updateTablet({
        //   params: { locationId },
        //   body,
        // })
        return await this.client.patch(`locations/${locationId}/tablet`, body);
    }
}
exports.default = LocationAPI;
//# sourceMappingURL=index.js.map